import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MembershipRulePeriods } from '@guryou/core';
const usePeriods = function () {
  let noPeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const {
    t
  } = useTranslation();
  const [levels, setLevels] = useState();
  const defaultValues = [{
    name: t('MEMBERSHIP_RULES.day'),
    value: MembershipRulePeriods.day
  }, {
    name: t('MEMBERSHIP_RULES.week'),
    value: MembershipRulePeriods.week
  }, {
    name: t('MEMBERSHIP_RULES.month'),
    value: MembershipRulePeriods.month
  }, {
    name: t('MEMBERSHIP_RULES.allPeriod'),
    value: MembershipRulePeriods.allPeriod
  }, {
    name: t('MEMBERSHIP_RULES.noPeriod'),
    value: MembershipRulePeriods.noPeriod
  }];
  if (!levels) {
    setLevels(defaultValues);
  }
  return !noPeriod ? levels : levels === null || levels === void 0 ? void 0 : levels.filter(x => x.value !== MembershipRulePeriods.noPeriod);
};
export { usePeriods };